// Custom field types for use in forms, dialogs, and models
export const CUSTOM_FIELD_TYPES = {
    TEXT: "text",
    NUMBER: "number",
    DATE: "date",
    BOOLEAN: "boolean",
    EMAIL: "email",
    PHONE: "phone",
    SELECT_BOX: "select box",
    TEXTAREA: "textarea",
};
export const CUSTOM_FIELD_TYPE_OPTIONS = [
    { value: CUSTOM_FIELD_TYPES.BOOLEAN, label: "Boolean" },
    { value: CUSTOM_FIELD_TYPES.DATE, label: "Date" },
    { value: CUSTOM_FIELD_TYPES.EMAIL, label: "Email" },
    { value: CUSTOM_FIELD_TYPES.NUMBER, label: "Number" },
    { value: CUSTOM_FIELD_TYPES.PHONE, label: "Phone" },
    { value: CUSTOM_FIELD_TYPES.SELECT_BOX, label: "Select box" },
    { value: CUSTOM_FIELD_TYPES.TEXT, label: "Text" },
    { value: CUSTOM_FIELD_TYPES.TEXTAREA, label: "Textarea" },
];
//# sourceMappingURL=customFieldTypes.js.map